import { ChemistryProfiles } from "../../../functions/calculateChemistry";
import axios from "../../apiFc24";

export const getChemistryProfiles = async () => {
  const res = await axios.get<ChemistryProfiles>("/players/chemistry-profiles");
  return res.data;
};
